import { combineReducers } from "redux";
import compassAppReducer from "../components/compass-app/reducer";
import loaderReducer from "../components/common/loader/reducer";

const rootReducer = combineReducers({
  compassApp: compassAppReducer,
  loader:loaderReducer,

});

export default rootReducer;